import React from 'react'

import GenerateWinninAIReportModal from 'components/GenerateWinninAIReportModal'
import GenerateWinninAIReportUseCaseModal from 'components/GenerateWinninAIReportUseCaseModal'
import { useWinninAIReport } from 'contexts/WinninAIReportContext'

const ALLOWED_TYPES = {
  territory_analysis: 'territory_analysis',
  search_creators: 'search_creators',
}

export default function WinninAIReportModals() {
  const { winninAIReport } = useWinninAIReport()

  const shouldRenderUseCaseModal = ALLOWED_TYPES?.[winninAIReport?.reportType]

  const showWinninAIReportModal =
    winninAIReport?.id && winninAIReport?.entity && !winninAIReport?.reportType && !winninAIReport?.outputLanguage
  const showWinninAIReportUseCaseModal =
    winninAIReport?.id &&
    winninAIReport?.entity &&
    winninAIReport?.reportType &&
    winninAIReport?.outputLanguage &&
    shouldRenderUseCaseModal
  return (
    <>
      {showWinninAIReportModal && <GenerateWinninAIReportModal />}
      {showWinninAIReportUseCaseModal && <GenerateWinninAIReportUseCaseModal />}
    </>
  )
}
